
<template>
    <div>
        <mars-view class="note" @click.native="allClick"><top-bar :no-show-home="true" :bg-color="topBar.bgColor" :home-flag="true" text-color="#000" logo-url="https://lvlin-base.cdn.bcebos.com/law/pages/home/lvlin-logo-new.png"></top-bar><mars-view style="background: #fff"><mars-view v-if="picList.length > 0" class="pic"><mars-view id="pic-box" class="pic-box"><mars-swiper class="pic-box-swiper" :autoplay="false" :interval="2500" :style="{height: picHeight + 'px'}" @change="swiperChange"><mars-swiper-item v-for="item,index in picList" :key="index" :class="['pic-box-swiper-box', item.extraClass]"><template><mars-image class="pic-box-swiper-item-image" :src="item.src" :preview="true" mode="aspectFit" @error="picErr(index)" @load="data => picLoad(data, index)"></mars-image></template></mars-swiper-item></mars-swiper><mars-view v-if="picList.length > 1" class="page-num">
                    {{ curSwiper + 1 }}/{{ picList.length }}
                </mars-view><mars-view v-if="picList.length > 1" class="pic-box-swiper-point-wrapper"><mars-view class="pic-box-swiper-point-content" :style="{'left': scrollX + 'px'}"><mars-view v-for="item,index in picList" :key="index" :class="{
                                'pic-box-swiper-point': true,
                                'current': curSwiper === index,
                                'small': picList.length > 5 && (curSwiper < 4 && index >= 4
                                    || curSwiper >= 4 && (curSwiper - index >= 3 && curSwiper !== picList.length - 1
                                        || index > curSwiper && index !== picList.length - 1)
                                    || curSwiper === picList.length - 1 && curSwiper - index > 3),
                            }"></mars-view></mars-view></mars-view></mars-view></mars-view><lawyer-info :lawyer-info="lawyerInfo" @openConsultForm="openConsultForm('lvlin_note_lawyer_btn')"></lawyer-info><mars-view v-if="noteData"><note-content :note="noteData"></note-content></mars-view><mars-view class="line"></mars-view><mars-view class="ads"><template><template v-if="adH5Data"><ad-h5 :ads-data="adH5Data" :start-index="0" :end-index="1"></ad-h5></template></template></mars-view></mars-view><mars-view v-if="recommendListLeft && recommendListLeft.length" id="moreRecommend" class="recommend-section" data-serverid="17291" data-area="recommend_notes_show"><mars-view class="section-title">更多内容推荐</mars-view><mars-view class="recommend-content"><mars-view class="recommend-left"><mars-view v-for="(item, index) in recommendListLeft" :key="index" class="recommenf-item"><recommend-card :recommend-info="item"></recommend-card><mars-view v-if="!index" class="consult-box"><consult-card :consult-cnt="consultCnt" @clickConsult="openConsultForm('lvlin_note_consult_card')"></consult-card></mars-view></mars-view></mars-view><mars-view class="recommend-right"><mars-view class="recommenf-item"><recommend-lawyer :lawyer-list="lawyerList"></recommend-lawyer></mars-view><mars-view v-for="(item, index) in recommendListRight" :key="index" class="recommenf-item"><recommend-card :recommend-info="item"></recommend-card></mars-view></mars-view></mars-view><mars-view class="content-end">
            没有更多内容了
        </mars-view></mars-view><mars-view class="blank"></mars-view><mars-view class="bottom-wrapper"><mars-view class="consult-btn" @click.native="openConsultForm('lvlin_note_bottom_btn')"><mars-view class="main-title">预约专业律师回电</mars-view><mars-view class="sub-title">
                已解决<span class="baidufont">{{ count }}</span>次法律问题
            </mars-view></mars-view></mars-view><clue-collection-popup :show="showConsultPopup" :from="clueFrom" law-clue-config-image-url="https://lvlin-base.cdn.bcebos.com/law/pages/clue-collection/clue-collection-banner1.png" :nqid="encodeQid" @closeEvent="closeClueCollectionPopup"></clue-collection-popup></mars-view>
    </div>
</template>

<script>
/* globals getApp, Page, swan, getCurrentPages, globalData */
import Topbar from "../../components/common/topbar.vue";
import lawyerInfo from "./components/lawyerInfo.vue";
import noteContent from "./components/noteContent.vue";
import clueCollectionPopup from "../../components/common/clueCollectionPopup.vue";
import adH5 from "../../components/ad/ad-h5.vue";
import { request } from '../../static/utils/request.js';
import { reqPathTo } from '../../static/utils/env.js';
import { getSearchQuery } from '../../static/utils/index';
import recommendLawyer from "./components/recommendLawyer.vue";
import recommendCard from "./components/recommendCard.vue";
import consultCard from "./components/consultCard.vue";
import log from '../../static/utils/ubcLog';
import { inSightObservers, inSightObserverDisconnects } from '../../common/js/repeatExposureLog.js';
export default {
  components: {
    'top-bar': Topbar,
    'lawyer-info': lawyerInfo,
    'clue-collection-popup': clueCollectionPopup,
    'note-content': noteContent,
    'ad-h5': adH5,
    'recommend-lawyer': recommendLawyer,
    'recommend-card': recommendCard,
    'consult-card': consultCard
  },
  data() {
    return {
      topBar: {
        // 顶部bar数据
        bgColor: '#fff'
      },
      curSwiper: 0,
      // 当前选中
      picList: [],
      // 轮播图片列表
      lawyerInfo: null,
      showConsultPopup: false,
      // 是否展示咨询表单弹窗
      noteData: null,
      scrollX: 0,
      adH5Data: null,
      adSwanList: [],
      // 小程序广告数据
      lawyerList: [],
      // 推荐律师
      recommendListLeft: [],
      // 第一列数据
      recommendListRight: [],
      // 第二列数据
      count: 0,
      consultCnt: 0,
      picHeight: 0,
      pageWidth: 0,
      // 页面宽度
      clueFrom: '' // 咨询来源点位标识
    };
  },

  methods: {
    // 轮播切换
    swiperChange(e = {}) {
      const current = e.detail && e.detail.current;
      // 滑动打点
      log.send && log.send({
        serverId: 17291,
        area: current < this.curSwiper ? 'picture_left_click' : 'picture_right_click',
        action: 'click'
      });
      // 为了滑动的同时改变选中值
      setTimeout(() => {
        this.curSwiper = current;
      }, 200);
      if (this.picList.length <= 5 || current >= 4 && current === this.picList.length - 1) {
        return;
      }
      let n = 0;
      if (current >= 4 && current !== this.picList.length - 1) {
        n = current - 3;
      }
      this.translateX(n);
    },
    /**
     * 轮播下的圆点是否变小
     * @param {Number} index 圆点下标
     */

    isSmall(index) {
      let len = this.picList.length;
      if (len <= 5) {
        return false;
      }
      return this.curSwiper < 4 && index >= 4 || this.curSwiper >= 4 && (this.curSwiper - index >= 3 && this.curSwiper !== len - 1 || index > this.curSwiper && index !== len - 1) || this.curSwiper === len - 1 && this.curSwiper - index > 3;
    },
    // 打开咨询表单弹窗
    openConsultForm(from = 'lvlin_note') {
      this.clueFrom = from + '_h5';
      this.showConsultPopup = true;
    },
    // 关闭咨询表单弹窗
    closeClueCollectionPopup() {
      this.showConsultPopup = false;
    },
    // 向左滑动 n * 11个 px
    translateX(n) {
      this.scrollX = -11 * n;
    },
    /**
     * 获取推荐律师
     */

    getRecommendLawyer() {
      request({
        url: reqPathTo('questionrecommend', {}, '', 'swan/ajax')
      }).then(res => {
        if (!res.data || res.data.errNo !== 0) {
          this.lawyerList = [];
          return;
        }
        const {
          recommendVipLawyerInfo = {}
        } = res.data || {};
        this.lawyerList = recommendVipLawyerInfo.recommend_list || [];
      }).catch(() => {
        this.lawyerList = [];
      });
    },
    /**
     * 处理推荐列表，分成左右两列
     */

    handleRecomendList(recommendList) {
      // 过滤掉没有图片的笔记
      let list = recommendList.filter(item => {
        let question = item && item.question;
        if (question) {
          let content = question.normal_replys_arr && question.normal_replys_arr[0] || question.special_replys_arr && question.special_replys_arr[0];
          let pic = content.img_url && content.img_url[0] || '';
          if (pic) {
            return item;
          }
        }
      }) || [];
      if (!list || !list.length) {
        return;
      }
      list.forEach((item, index) => {
        const {
          lawyerInfo,
          question
        } = item || {};
        if (lawyerInfo && question) {
          let content = question.normal_replys_arr && question.normal_replys_arr[0] || question.special_replys_arr && question.special_replys_arr[0];
          let recommendItem = {
            pic: content.img_url && content.img_url[0] || '',
            title: question.title,
            name: lawyerInfo.name,
            avatar: lawyerInfo.avatar,
            encodeQid: question.encode_qid
          };
          // 奇数
          if (index % 2) {
            this.recommendListRight.push(recommendItem);
          } // 偶数
          else {
            this.recommendListLeft.push(recommendItem);
          }
        }
      });
      setTimeout(() => {
        inSightObservers('#moreRecommend', '', {}, [], false, true, true, {
          threshold: 0.1
        });
        inSightObservers('#recommendLawyerCard', '', {}, [], false, true, true, {
          threshold: 0.2
        });
        inSightObservers('#consultCard', '', {}, [], false, true, true, {
          threshold: 0.2
        });
      }, 500);
    },
    /**
     * 小程序获取广告数据
     *
     */

    getSwanAds() {
      request({
        url: reqPathTo('getrelads', {}, '', 'lawqb'),
        data: {
          qid: this.encodeQid,
          word: this.noteData && encodeURI(this.noteData.title) || '',
          hitEid: 11079,
          sfrom: 'lvlin',
          searchQueryEnc: getSearchQuery()
        },
        loginNeeded: false,
        needBduss: true
      }).then(data => {
        const res = data && data.data || {};
        if (!res.data) {
          return;
        }
        let aspList = [];
        // asp逻辑
        if (res.data.asp && res.data.asp.ad) {
          res.data.asp.ad.length && res.data.asp.ad.forEach((item, index) => {
            aspList[index] = {
              data: {
                res: {
                  ad: [item]
                }
              }
            };
          });
        }
        this.adSwanList = aspList.length ? aspList.slice(0, 1) : [];
      });
    },
    /**
     * h5获取广告数据
     *
     */

    getH5Ads() {
      request({
        url: reqPathTo('getqbcontent', {}, '', 'lawqb'),
        data: {
          qid: this.encodeQid,
          word: this.noteData && this.noteData.title || '',
          hitEid: 11079,
          sfrom: 'lvlin',
          searchQueryEnc: getSearchQuery()
        },
        loginNeeded: false,
        needBduss: true
      }).then(res => {
        const data = res && res.data && res.data.data && res.data.data.adsAll || {};
        this.adH5Data = Array.isArray(data.ads) ? null : data.ads;
      });
    },
    // 页面总点击计数
    allClick() {
      log.send({
        serverId: 17291,
        area: 'all_click',
        action: 'click'
      });
    },
    // 图片加载失败，显示加载失败图片
    picErr(index) {
      this.$set(this.picList[index], 'extraClass', 'error');
    },
    // 图片加载成功，隐藏图片加载状态
    picLoad(data = {}, index) {
      if (index === 0) {
        let height = data.detail && data.detail.height;
        let width = data.detail && data.detail.width;
        this.picHeight = height > width ? this.pageWidth * 4 / 3 : this.pageWidth * 3 / 4;
      }
      this.$set(this.picList[index], 'extraClass', '');
    },
    // 获取笔记详情
    getDetail() {
      request({
        url: reqPathTo('get_qb_by_qid', {}, '', 'falv/content'),
        data: {
          encodeQid: this.encodeQid
        }
      }).then(data => {
        const res = data && data.data || {};
        if (+res.code !== 0 || !res.data) {
          return;
        }
        const {
          question,
          lawyerInfo,
          onlioneConsultants
        } = res.data || {};
        this.lawyerInfo = lawyerInfo || {};
        this.count = onlioneConsultants;
        if (!question) {
          return;
        }
        this.noteData = question;
        this.noteData.content = question.normal_replys_arr && question.normal_replys_arr[0] || question.special_replys_arr && question.special_replys_arr[0];
        let picList = this.noteData.content && this.noteData.content.img_url || [];
        this.picList = picList.map(src => {
          return {
            src,
            extraClass: 'loading'
          };
        });
        this.getH5Ads();
      });
    },
    // 获取推荐列表
    getRecommendList() {
      request({
        url: reqPathTo('get_recommend_qb_list', {}, '', 'falv/content')
      }).then(data => {
        const res = data && data.data || {};
        if (+res.code !== 0 || !res.data) {
          return;
        }
        const {
          question_list,
          consult_cnt
        } = res.data || {};
        this.consultCnt = consult_cnt;
        this.handleRecomendList(question_list);
      });
    }
  },
  created() {
    (function (data) {
      this.encodeQid = data.qid || '';
      if (!this.encodeQid) {
        return;
      }
      this.getDetail();
      this.getRecommendList();
      this.getRecommendLawyer();
    }).call(this, this.$route.query);
    (function () {
      // 页面曝光打点
      log.send && log.send({
        serverId: 17291,
        area: 'all_show',
        action: 'show'
      });
      if (!this.encodeQid) {
        return;
      }
      const winData = this.$api.getSystemInfoSync();
      this.pageWidth = winData.windowWidth; // 屏幕宽度
      this.picHeight = this.pageWidth * 3 / 4; // 图片高度初值
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  mounted() {
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  destroyed() {
    (function () {
      inSightObserverDisconnects();
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      inSightObserverDisconnects();
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.note {
  width: 100%;
  overflow: hidden;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.note .pic {
  width: 100%;
}
.note .pic .pic-box {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.note .pic .pic-box .pic-box-swiper .pic-box-swiper-box {
  width: 100%;
  height: 100%;
}
.note .pic .pic-box .pic-box-swiper .pic-box-swiper-box.loading {
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/note/pic_loading.png') no-repeat center center / 0.96rem 1.24rem;
}
.note .pic .pic-box .pic-box-swiper .pic-box-swiper-box.error {
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/note/pic_error.png') no-repeat center center / 0.96rem 1.24rem;
}
.note .pic .pic-box .pic-box-swiper .pic-box-swiper-item-image {
  width: 100%;
  height: 100%;
}
.note .pic .pic-box .page-num {
  font-family: PingFang SC;
  width: 0.37rem;
  height: 0.22rem;
  position: absolute;
  border-radius: 0.11rem;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  text-align: center;
  font-size: 0.12rem;
  font-weight: 500;
  line-height: 0.22rem;
  right: 0.17rem;
  bottom: 0.3rem;
}
.note .pic .pic-box .pic-box-swiper-point-wrapper {
  margin: 0.1rem auto 0;
  max-width: 52px;
  overflow: hidden;
}
.note .pic .pic-box .pic-box-swiper-point-wrapper .pic-box-swiper-point-content {
  display: flex;
  position: relative;
  transition: all 0.2s ease 0.2s;
  height: 0.07rem;
}
.note .pic .pic-box .pic-box-swiper-point-wrapper .pic-box-swiper-point {
  width: 6px;
  height: 6px;
  background: #d8d8d8;
  border-radius: 50%;
  margin-right: 5px;
  flex-shrink: 0;
}
.note .pic .pic-box .pic-box-swiper-point-wrapper .pic-box-swiper-point.current {
  background: #4e6ef2;
}
.note .pic .pic-box .pic-box-swiper-point-wrapper .pic-box-swiper-point.small {
  transform: scale(0.7);
}
.note .pic .pic-box .pic-box-swiper-point-wrapper .pic-box-swiper-point:last-child {
  margin-right: 0;
}
.note .line {
  height: 1px;
  margin: 0 0.17rem;
  transform: scaleY(0.5);
  background: #e8e8e8;
}
.note .recommend-section {
  background: #f5f6f9;
}
.note .recommend-section .section-title {
  font-family: PingFang SC;
  padding: 0.17rem 0.17rem 0.13rem;
  color: #1e1f24;
  font-size: 0.18rem;
  font-weight: 500;
  line-height: 1;
  background: linear-gradient(180deg, #fff 0, #fff 30%, #f5f6f9 100%);
}
.note .recommend-section .recommend-content {
  display: flex;
  justify-content: center;
}
.note .recommend-section .recommend-content .recommend-left {
  margin-right: 0.06rem;
}
.note .recommend-section .recommend-content .recommenf-item {
  flex-shrink: 0;
  margin-bottom: 0.06rem;
}
.note .recommend-section .recommend-content .recommenf-item .consult-box {
  margin-top: 0.05rem;
}
.note .recommend-section .content-end {
  padding: 0.32rem 0 0.26rem;
  text-align: center;
  color: #848691;
  font-size: 0.13rem;
  font-weight: 400;
  line-height: 1;
}
.note .blank {
  width: 100%;
  height: 0.55rem;
}
.note .bottom-wrapper {
  background-color: #fff;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  height: 0.55rem;
  width: 100%;
  z-index: 10;
  position: fixed;
  bottom: 0;
}
.note .bottom-wrapper .consult-btn {
  background: linear-gradient(90deg, #fd503e 0.55%, #ff4060 99.92%);
  color: #fff;
  line-height: 1;
  text-align: center;
  padding: 0.09rem 0;
  height: 100%;
  box-sizing: border-box;
}
.note .bottom-wrapper .consult-btn .main-title {
  text-align: center;
  font-size: 0.18rem;
  font-weight: 500;
  font-family: PingFang SC;
}
.note .bottom-wrapper .consult-btn .sub-title {
  font-size: 0.12rem;
  font-weight: 400;
  margin-top: 0.06rem;
}

</style>
